<template>
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.4831 8.53513C16.8175 9.06289 17.1 9.62172 17.3269 10.2038C20.288 10.9191 22.5 13.5722 22.5 16.7479C22.5 20.4697 19.4719 23.4977 15.75 23.4977C12.0281 23.4977 9 20.4697 9 16.7479C9 13.6331 11.1342 11.0471 14.0091 10.2793C14.625 11.2951 15 12.4744 15 13.748C15 16.326 13.5295 18.546 11.3986 19.6817C11.7 20.1135 12.0643 20.4978 12.4795 20.8217C14.8847 19.3803 16.5 16.7559 16.5 13.748C16.5 10.1677 14.2148 7.12845 11.0269 5.98754L13.0312 3.07105L10.1808 0.998291H6.31922L3.46875 3.07105L5.47312 5.98754C2.28516 7.12845 0 10.1677 0 13.748C0 18.3042 3.69365 21.9978 8.25 21.9978C8.6107 21.9967 8.97091 21.971 9.32812 21.9209C11.5214 24.6467 15.1959 25.6919 18.4955 24.5286C21.7951 23.3652 24.0015 20.2465 24 16.7479C24 12.4392 20.6953 8.90684 16.4831 8.53513ZM5.53125 3.42542L6.80719 2.49825H9.69281L10.9688 3.42542L9.47391 5.59896C9.06902 5.53494 8.65991 5.50125 8.25 5.49818C7.84009 5.50125 7.43098 5.53494 7.02609 5.59896L5.53125 3.42542ZM1.5 13.748C1.5 17.4697 4.52812 20.4978 8.25 20.4978C8.2772 20.4978 8.30335 20.494 8.3295 20.4902C8.35292 20.4868 8.37633 20.4835 8.40047 20.4828C7.80903 19.3266 7.50042 18.0466 7.5 16.7479C7.5 13.1499 9.81328 10.1115 13.0261 8.98418C11.7624 7.71215 10.0431 6.99722 8.25 6.99814C4.52812 6.99814 1.5 10.0262 1.5 13.748Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "RingsWeddingIcon",
});
</script>
